import { Injectable } from '@angular/core';
import { AdapterService } from './adapter.service';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
const routes = {
  path: () => 'order',
  orderItem: () => 'orderItem',
  activityLog: () => 'activity-log',
  shippingDetails: () => 'shipping-details'
}
@Injectable({
  providedIn: 'root'
})
export class OrderService {
  constructor(private apiService: ApiService,
    private _adapterService: AdapterService) { }

  getList(model: any): Observable<any> {
    return this.apiService.get(`${routes.path()}?skip=${model.skip}&take=${model.take}&userId=${model.userId}&sort=${model.sort}&sortBy=${model.sortBy}&searchString=${model.searchString}&dateFrom=${model.dateFrom || ""}&dateTo=${model.dateTo || ""}`);
  }

  getById(id: number) {
    return this.apiService.get(`${routes.path()}/${id}`)
  }

  getOrderItems(orderId: number) {
    return this.apiService.get(`${routes.orderItem()}?orderHeaderId=${orderId}`)
  }

  getActivityLogs(id: number) {
    return this.apiService.get(`${routes.path()}/${routes.activityLog()}/${id}`)
  }

  getShippingDetails(orderId: number) {
    return this.apiService.get(`${routes.path()}/${routes.shippingDetails()}/${orderId}`)
  }

  requestCancel(model: any) {
    return this.apiService.post(`${routes.path()}/requestcancel`, model);
  }

}
